export default __webpack_public_path__ + "static/media/play.ffce27f5.svg";